export default __webpack_public_path__ + "static/media/item_m.f64bd158.png";